import storedRequestData from './storedRequestData';

const root = {
	storedRequestData
};

export default root;
